import { cn } from '@/utils/cn';
import type { DiffStats } from './types';

export const DiffStat = ({
  add,
  del,
  mod,
  className,
  unit = 'řádky a položky',
}: DiffStats & { className?: string; unit?: string }) => (
  <span
    title={`${unit}: přidáno ${add}, odebráno ${del}, změněno ${mod}`}
    aria-label={`${unit}: přidáno ${add}, odebráno ${del}, změněno ${mod}`}
    className={cn('inline-flex items-center gap-1.5 font-mono text-[11px] tabular-nums', className)}
  >
    {add > 0 && <span className="text-emerald-600">+{add}</span>}
    {del > 0 && <span className="text-red-600">−{del}</span>}
    {mod > 0 && <span className="text-amber-600">~{mod}</span>}
    {add + del + mod === 0 && <span className="text-neutral-300">—</span>}
  </span>
);
